<template>
    <div>
        <div class="p-5 position-relative">
            <div class="mt-3 mb-5">
                <div class="text-white text-center position-relative" style="z-index: 5">
                    <h1>Beyond four walls</h1>
                    <h4>
                        Ladder Club generates new revenue by connecting
                        <br />your trainers digitally with past members &amp; new clients.
                    </h4>
                </div>
            </div>
            <wave flipped />
        </div>
        <div class="bg-white text-dark text-center p-4">
            <img src="@/assets/clubfeatured.png" style="max-width: 80vw;" />
        </div>
        <v-container class="bg-white" fluid>
            <v-row>
                <v-column class="p-5 text-dark" cols="12" md="6">
                    <h1>Get in touch</h1>
                    <h4>If you are interested in being a Ladder Club partner, or looking for more information, send us a note.</h4>
                </v-column>
                <v-column class="p-5" cols="12" md="6">
                    <contact-form />
                </v-column>
            </v-row>
        </v-container>
    </div>
</template>

<script>
import Wave from "@/components/Wave";
import ContactForm from "@/components/ContactForm";

export default {
    name: "IndexClubView",
    components: {
        ContactForm,
        Wave
    }
};
</script>

<style scoped lang="scss">
.wave {
    background-color: $white;
    width: 100%;
    height: 4rem;
    position: absolute;
    bottom: 0px;
    left: 0px;
}

/* define the animation */
@keyframes outside {
    0% {
        transform: scale(1);
        opacity: 0.3;
    }
    100% {
        transform: scale(1.6);
        opacity: 0;
    }
}
.map {
    height: 300px;
}
</style>